import { useCallback } from "react";
import { Container, Row } from "reactstrap";
import { Toolbar } from "../../../../components/Toolbar";
import { BoolCell } from "../../../../components/grid/cells/BoolCell";
import { AdministrateTable } from "../../../components/AdministrateTable";
import { AdministrateBackgroundExportButton } from "../../../components/AdministrateBackgroundExportButton";
import { makeColumns, DESTROY, UPDATE, useAdministrateTable, useCreatePermission } from "../../../utils";
import { AvailityErrorRuleActionCell } from "../components/AvailityErrorRuleActionCell";
import { AvailityErrorRuleModal } from "../components/AvailityErrorRuleModal";
import { ImportAvailityErrorRulesModal } from "../components/ImportAvailityErrorRulesModal";

const useColumns = makeColumns(() => [
  { id: "id", accessor: "id", Header: "ID" },
  { id: "http_response_code", accessor: "httpResponseCode", Header: "HTTP Code" },
  { id: "availity_status_code", accessor: "availityStatusCode", Header: "Availity Status" },
  { id: "payor.name", accessor: "payor.name", Header: "Payor", disableSortBy: true },
  { id: "message_regex", accessor: "messageRegex", Header: "Message Regex", disableSortBy: true },
  { id: "new_status", accessor: "newStatus", Header: "New Status" },
  { id: "comment_text", accessor: "commentText", Header: "Comment", disableSortBy: true },
  { id: "comment_public", accessor: "commentPublic", Header: "Public", Cell: BoolCell },
  { id: "submission_attempt_successful", accessor: "submissionAttemptSuccessful", Header: "Attempt", Cell: BoolCell },
  { id: "payor_switch_mode", accessor: "payorSwitchMode", Header: "Payor Switch" },
  { id: "new_payor.name", accessor: "newPayor.name", Header: "New Payor", disableSortBy: true },
  {
    id: "actions",
    accessor: "actions",
    Header: "Actions",
    Cell: AvailityErrorRuleActionCell,
    disableFilters: true,
    disableSortBy: true,
  },
]);

export const AvailityErrorRulesTab = () => {
  const { tableRef, allFilters, setTableFilters } = useAdministrateTable();
  const [canCreate] = useCreatePermission("AvailityErrorRule");
  const columns = useColumns();
  const onSaved = useCallback(
    (message = "Saved Availity error rule.", errorDetails = []) => {
      tableRef.current?.refresh?.();
      tableRef.current?.setMessage?.(message, errorDetails.length > 0 ? "warning" : "success", errorDetails);
    },
    [tableRef]
  );

  return (
    <Container fluid>
      <Row className="align-items-center mb-3">
        <Toolbar className="ms-auto gap-2">
          <AdministrateBackgroundExportButton outline exportUrl="/admin/availity_error_rules/export" filters={allFilters} ref={tableRef} />
          {canCreate && <ImportAvailityErrorRulesModal outline onImport={onSaved} />}
          {canCreate && <AvailityErrorRuleModal color="primary" onSaved={onSaved} />}
        </Toolbar>
      </Row>
      <AdministrateTable
        resourceUrl="/admin/availity_error_rules.json"
        resourceName="availity_error_rule"
        permissions={[DESTROY, UPDATE]}
        onFilteredChange={setTableFilters}
        columns={columns}
        ref={tableRef}
      />
    </Container>
  );
};
